export const PROPERTY_MANAGEMENT_APIS = Object.freeze({
    LIST_PROPERTY: `/all-properties`,
    CREATE_PROPERTY: '/properties',
    SINGLE_PROPERTY_UPDATE_DELETE: (id: string) => `/properties/${id}`,
    DUPLICATE_PROPERTY: `/properties/duplicate`,
    PROPERTY_TAGS: '/property-filters',
    ALL_AMENITIES: '/amenities',
    CREATE_PROPERTY_AMENITY: '/properties/amenities',
    GET_PROPERTY_AMENITY: (id: string) => `/property-amenities/${id}`,
    UPDATE_DELETE_PROPERTY_AMENITY: (id: string) => `/properties/amenities/${id}`,
    CREATE_PROPERTY_BLOCKS: `/properties/rooms`,
    GET_PROPERTY_BLOCKS: (id: string) => `/property-rooms/${id}`,
    UPDATE_DELETE_PROPERTY_BLOCKS: (id: string) => `/properties/rooms/${id}`,
    CITIES: '/city',
    CREATE_MASTER_PROPERTY: '/master-property',
    GET_MASTER_PROPERTIES: `/master-property`,
    UPDATE_MASTER_PROPERTY: (id: string) => `/master-property/${id}`,
    GET_SUB_PROPERTIES: (id: string) => `/master/sub-properties/${id}`,
    GET_ALL_SUB_PROPERTIES: `/master/sub-properties`,
    GET_PROPERTY_MANAGERS: '/users',
    GET_MASTER_PROPERTY: (id: string) => `/master-property/${id}`,
    GET_COLLECTION_DETAILS: `/ledger`,
    GET_TENANT_DETAILS: (id: string | undefined) => `/tenants/master-property/${id}`,
    GET_TENANT_ID: (id: string | undefined) => `/tenant/single/${id}`,
    POST_BULK_PROPERTY_BLOCKS: `/properties/bulk-rooms`,
    AREA_GET: `/geocoding/area`,
    OFFBOARD_PROPERTY: (id: string) => `/properties/master-property/offboard/${id}`,
    TENANTS_DETAILS_GET: `/booking`,
    PROPERTY_INVENTORY_GET: `/property-inventory`,
    CREATE_PROPERTY_INVENTORY: `/assign-inventory`,
    DELETE_PROPERTY_INVENTORY: (item_id: string) => `/property-inventory/${item_id}`,
    FINANCIAL_DETAILS_GET_POST: `/master-property/mp-payment-transactions`,
    FINANCIAL_DETAILS_UPDATE_DELETE: (id: string) => `/master-property/mp-payment-transactions/${id}`,
    MASTER_PROPERTY_FINANCE_DETAILS_UPDATE: (id: string) => `/master-property/${id}`,
    MASTER_PROPERTY_AGREEMENT_GET: `/master-property/agreement`,
    MASTER_PROPERTY_AGREEMENT_POST: `/master-property/agreement`,
    MASTER_PROPERTY_AGREEMENT_DOCUMENTS_UPDATE: (id: string) => `/master-property/agreement/${id}`,
    MASTER_PROPERTY_AGREEMENT_DOCUMENTS_DELETE: (id: string) => `/master-property/agreement/${id}`
})

export const FILE_UPLOAD_URL = Object.freeze({
    path: `/upload-file`,
    docpath: `/upload-document`
})

export const WEBSITE_CONTENT_APIS = Object.freeze({
    LIST_FAQ_GET_POST: `/faq`,
    FAQ_UPDATE_DELETE: (id: string) => `/faq/${id}`,
    WEBSITE_CONTENT_GET: `/website-content`,
    WEBSITE_CONTENT_UPDATE: `/website-content`,
    ADDRESS_GET_POST: `/address`,
    ADDRESS_UPDATE_DELETE_SINGLEGET: (id: string) => `/address/${id}`,
    TESTIMONIALS_GET_POST: `/testimonials`,
    TESTIMONIALS_UPDATE_DELETE: (id: string) => `/testimonials/${id}`,
    GET_CREATE_DEPARTMENTS: `/department`,
    UPDATE_DEPARTMENT: (id: string) => `/department/${id}`,
    GET_JOBS: `/jobs`,
    CREATE_JOB: `/job`,
    UPDATE_JOB: (id: string) => `/job/${id}`,
    GET_JOB_APPLICATIONS: `/application`,
    GET_SINGLE_APPLICATION: (id: string) => `/application/${id}`,
    UPDATE_APPLICATION: (id: string) => `/application/${id}`
})

export const USER_MANAGEMENT_APIS = Object.freeze({
    USERS_GET_POST: `/users`,
    USER_ROLES: `/role`,
    UPDATE_USER: (id: string) => `/users/${id}`,
    DELETE_USER: (id: string) => `/user/${id}`,
    GET_USER: (id: string) => `/users/single/${id}`,
    USER_PROFILE: (cognitoId: string) => `/users/profile/${cognitoId}`,
    RESET_PASSOWRD: `/reset-password`,
    MASTER_PROPERTIES: `/master-property`
})

export const LEADS_APIS = Object.freeze({
    LIST_LEADS: `/leads`,
    LEADS_UPDATE: (id: string) => `/leads/${id}`
})

export const BLOGS_APIS = Object.freeze({
    BLOGS_GET_POST: `/website-content/blog`,
    BLOG_TAGS: `/blog-tags`,
    BLOG_UPDATE_DELETE_SINGLEGET: (id: string) => `/website-content/blog/${id}`
})

export const MASTER_DIRECTORY_APIS = Object.freeze({
    ROLES_POST_GET: `/role`,
    ROLE_UPDATE_DELETE: (id: string) => `/role/${id}`,
    AMENITIES_GET: `/amenities`,
    CREATE_AMENITY: `/amenity`,
    AMENITY_UPDATE_DELETE: (id: string) => `/amenity/${id}`,
    LIST_PROPERTY_TAGS: `/property-tags`,
    CREATE_PROPERTY_TAG: `/property-tag`,
    PROPERTY_TAG_UPDATE_DELETE: (id: string) => `/property-tag/${id}`,
    CREATE_CITY: `/city`,
    CITY_GET: `/city`,
    CITY_UPDATE_DELETE: (id: string) => `/city/${id}`,
    INVENTORY_CATEGORY_GET: `/inventory-category`,
    INVENTORY_CATEGORY_POST: `/inventory-category`,
    INVENTORY_CATEGORY_UPDATE_DELETE: (id: string) => `/inventory-category/${id}`,
    INVENTORY_ITEM_GET: `/inventory-item`,
    INVENTORY_ITEM_POST: `/inventory-item`,
    INVENTORY_ITEM_UPDATE_DELETE: (id: string) => `/inventory-item/${id}`,
    INVENTORY_VENDOR_GET: `/inventory-vendor`,
    INVENTORY_VENDOR_POST: `/inventory-vendor`,
    INVENTORY_VENDOR_UPDATE_DELETE: (id: string) => `/inventory-vendor/${id}`,
    MODULE_GET: `/misc/module/get-all`,
    MODULE_POST: `/module`,
    MODULE_UPDATE_DELETE: (id: string) => `/module/${id}`,
    SUB_MODULE_GET: `/access-control`,
    SUB_MODULE_POST: `/misc/sub-module/create`,
    SUB_MODULE_UPDATE_DELETE: (id: string) => `/sub-module/${id}`,
    EMPTY_QR_CODE_BULK_POST: `/empty-uuid`,
    EMPTY_UPDATE_QR_CODE: (id: string) => `/empty-uuid/${id}`,
    EMPTY_QR_CODE_GET_ALL: `/empty-uuid`,
    EMPTY_QR_CODE_DELETE: (id: string) => `/empty-uuid/${id}`,
    APP_VERSION_GET_POST: `/app-version`,
    APP_VERSION_UPDATE: (id: string) => `/app-version/${id}`,
    APP_VERSION_DELETE: (id: string) => `/app-version/${id}`
})

export const ONBOARDING_APIS = Object.freeze({
    LIST_ONBOARDING: `/booking`,
    SINGLE_ONBOARDING: (id: string) => `/booking/single/${id}`,
    CREATE_ONBOARDING: `/booking/start-onboarding`,
    PAYMENT_LINK_ONBOARDING: `/payment/token/generate-link`,
    UPDATE_ONBOARDING: (id: string) => `/booking/${id}`,
    UPDATE_LIMITED_FIELDS_ONBOARDING: (id: string) => `/booking/update/${id}`,
    ONBOARDING_HANDOVER: (id: string) => `/booking/update/${id}`,
    CANCEL_ONBOARDING: (id: string) => `/booking/cancel-onboarding/${id}`,
    AGREEMENT_SENT: (id: string) => `/booking/update/${id}`,
    CREATE_COLLECTION_DETAILS: (id: string) => `/due/add-collection/${id}`,
    UPDATE_APPROVE_REJECT: (id: string) => `/tenant-document/${id}`,
    PENDING_PAYMENTS: (id: string) => `/booking/due/${id}`,
    SEARCH_PROPERTY: `/all-properties`,
    ONBOARDING_ISSUES_GET: `/issue`,
    ONBOARDING_ISSUE_PATCH: (id: string | undefined) => `/issue/${id}`,
    ADD_ONBOARDING_ISSUE: `/issue`,
    ONBOARDING_SUBTYPES_GET: `/issue/subtypes`,
    ONBOARDING_MOVE_IN_DATE_GET_PATCH: (id: string | undefined) => `/booking/move-in-date/${id}`,
    ONBOARDING_MOVE_OUT_DATE_GET: `/depart-requests`,
    DOCUMENT_URL: `/get-document`,
    TENANT_BY_NO: `/tenants`,
    RENTAL_DOCUMENT_UPLOAD: `/booking/rental-document`,
    RENTAL_DOCUMENT_UPDATE: (id: string | undefined) => `/booking/rental-document/${id}`,
    ONBOARDING_ALL_ACTIVITIES: (id: string) => `/activity/get-all/${id}`,
    COLLECTION_DETAILS: (id: string) => `/ledger/booking/${id}`,
    SEND_AGREEMENT: (id: string) => `/booking/agreement/${id}`,
    RESEND_AGREEMENT: (id: string) => `/booking/rental-agreement/new/${id}`,
    MANUAL_AGREEMENT_SEND: (id: string) => `/booking/manual-agreement/${id}`,
    CHANGE_MOBILE_NUMBER: `/booking/change-mobile`,
    COLLECTION_UPDATE_PATCH: (id: string) => `/ledger/${id}`,
    DUE_LINK: (id: string): string => `/get-due-link/${id}`,
    AGREEMENT_COPY_LINK: (id: string): string => `/booking/agreement/copy-link/${id}`,
    RECORD_DUE: (id: string): string => `/due/add-record/${id}`,
    RENTAL_DOCUMENT_DELETE: (id: string): string => `/booking/agreement/${id}`,
    ONBOARDING_INVENTORY_GET: `/property-inventory`,
    INSPECTION: '/inspection',
    INSPECTION_BY_ID: (id: string) => `/inspection/${id}`
})

export const INSPECTION_APIS = Object.freeze({
    INSPECTION: '/inspection',
    INSPECTION_BY_ID: (id: string) => `/inspection/${id}`
})

export const KYC_APIS = {
    KYC_CREATE: () => `/tenant-document`,
    KYC_GET: `/tenant-document`,
    KYC_UPDATE_DELETE: (id: string) => `/tenant-document/${id}`
}

export const RAISE_ISSUE_APIS = Object.freeze({
    LIST_RAISE_ISSUES: `/issue`,
    RAISE_ISSUE_UPDATE_SINGLEGET: (id: string) => `/issue/${id}`,
    CLOSE_MULTIPLE_ISSUES: `/close-many/issue`,
    SCHEDULE_VISIT_ISSUE: (id: string) => `/issue/${id}`,
    ISSUE_ALL_ACTIVITY: `/activities`
})

export const REPORTS_APIS = Object.freeze({
    RENEWAL: `/reports/get-report-renewal`,
    TENANT: `/reports/get-report-tenant`,
    ISSUES: `/reports/get-report-issues`,
    LEDGER: `/reports/get-report-ledger`,
    COLLECTIONS: `/reports/get-report-collections`,
    DUES: `/reports/get-report-dues`,
    CASHFLOW: `/reports/get-report-cashflow`,
    DEPARTED: `/reports/get-report-old-tenants`,
    EXPENSES: `/reports/get-report-expenses`,
    BED_ROOMS: `/reports/get-report-bedrooms`,
    MF: `/reports/get-report-MF`,
    BOOKING: `/reports/get-report-booking`,
    NOTICES: `/reports/get-report-notices`,
    OWNER: `/reports/get-report-owner`,
    RENT: `/reports/get-report-rent`
})

export const EVICTION_APIS = Object.freeze({
    EXPIRATION_AND_REQUEST: `/eviction`,
    EXPIRATION_PENDING_CHARGES: (id: string) => `/booking/due/${id}`,
    EXPIRATION_REQUEST_DELETE: (id: string) => `/eviction/${id}`,
    EXPIRATION_RENUEW: `/eviction/renew-tenure`,
    EVICTION_DOC_CREATE: `/eviction/renew-document`,
    ALL_TENANTS: `/eviction/get-by-status`,
    TENURE_EXPIRY_DEPART: (id: string) => `/eviction/depart/${id}`,
    EXPIRATION_DEPART_REQUEST: `/depart-requests`,
    RENEWED_TENANTS: `/eviction/renewal`,
    POST_MOVE_OUT_REQUEST: `/eviction`,
    UPDATE_MOVE_OUT_REQUEST: (id: string) => `/eviction/${id}`,
    GET_SINGLE_EVICTION_DETAILS: (id: string) => `/eviction/details/${id}`,
    GET_SINGLE_EVICTION_DETAILS_FROM_TENURE_EXPIRY: (id: string) => `/eviction/booking/${id}`,
    RENEWAL_SINGLE_EVICTION: (id: string) => `/eviction/renewal/${id}`,
    RENEWAL_SIGNER_DOC_UPDATE: (id: string) => `/eviction/renewal/resend-aggreement/${id}`,
    TERMINATE_TENANT: `/eviction/terminate`
})
export const EXPENSES_APIS = Object.freeze({
    EXPENSES_POST_GET: `/expenses`,
    EXPENSES_UPDATE_DELETE: (id: string) => `/expenses/${id}`,
    GET_ALL_DUES: `/booking/all-dues`,
    CREATE_DUE: `/due`,
    DUE_UPDATE_DELETE: (id: string) => `/due/${id}`,
    EXPENSE_CATEGORIES_POST_GET: `/misc/expense-category`,
    EXPENSE_CATEGORY_UPDATE_DELETE: (id: string) => `/misc/expense-category/${id}`,
    WHO_PAID: `/expenses/who-paid`,
    EXPENSE_PAID_BY_FILTER: `/expenses/paid-by`,
    KPIS_GET: '/kpis/expense-dues'
})
export const COLLECTION_APIS = Object.freeze({
    COLLECTION_POST_GET: `/ledger`,
    REFUND_GET: `/refunds`
})

export const ACCESS_CONTROL_APIS = Object.freeze({
    MODULE_LIST: `/access-control`,
    FUNCTIONS_LIST: `/access-control`,
    ROLE_MODULES: `/access-control/role`,
    DELETE_MODULE_SUBMODULE: (id: string) => `/access-control/${id}`
})

export const COMMON_APIS = Object.freeze({
    SIDEBAR_COUNT: `/sidebar-kpi`
})

export const PERFORMANCE_APIS = Object.freeze({
    ONBOARDING_STATS: (queryParams: string | undefined) => `/performance/onboarding-stats?${queryParams}`,
    ONBOARDING_GRAPH: (queryParams: string | undefined) => `/performance/onboarding-graph?${queryParams}`,
    REQUESTED_TABLE: (queryParams: string | undefined) => `/performance/requested-table?${queryParams}`,
    OCCUPANCY_STATUS: (queryParams: string | undefined) => `/performance/occupancy-status?${queryParams}`,
    ONBOARDING_TYPES_STATS: (queryParams: string | undefined) => `/performance/occupancy-type-status?${queryParams}`,
    GET_ALL_ISSUES: (queryParams: string | undefined) => `/performance/get-all-issues?${queryParams}`,
    ISSUE_TYPE_GRAPH: (queryParams: string | undefined) => `/performance/issue-type-graph?${queryParams}`,
    MOVE_SUMMARY: (queryParams: string | undefined) => `/performance/move-summary?${queryParams}`,
    MOVE_IN_TABLE: (queryParams: string | undefined) => `/performance/move-in-table?${queryParams}`,
    MOVE_OUT_TABLE: (queryParams: string | undefined) => `/performance/move-out-table?${queryParams}`,
    GET_SUMMARY: (queryParams: string | undefined) => `/performance/get-summary?${queryParams}`,
    MASTER_PROPERTY: (queryParams: string | undefined) => `/performance/master-property?${queryParams}`,
    PROPERTY: (queryParams: string | undefined) => `/performance/property?${queryParams}`,
    PERFORMANCE_REPORT: `/performance/admin-finance`
})

export const OWNER_APIS = Object.freeze({
    OWNER_UPDATE_DELETE: (id: string) => `/owner/${id}`,
    OWNER_POST_GET: `/owner`,
    OWNER_DOCUMENT_CREATE: `/owner-document`,
    OWNER_DOCUMENT_GET_UPDATE_DELETE: (id: string) => `/owner-document/${id}`,
    OWNER_PROPERTY_DETAILS: (id: string) => `/home-kpi/${id}`,
    OWNER_ISSUES: `/issue`,
    OWNER_PASSBOOK_GET_CREATE: `/passbook`,
    OWNER_PASSBOOK_GET_DETAILS: (id: string) => `/passbook/${id}`,
    OWNER_PASSBOOK_FINANCE: (ownerid: string) => `/passbook/rent-details/${ownerid}`,
    EXPENSES_GET: `/expenses`,
    GET_ALL_DUES: `/booking/all-dues`
})

export const ACCOUNTS_APIS = Object.freeze({
    ACCOUNTS_GET: `/fetch-linked-account`,
    SINGLE_ACCOUNT_GET: (id: string) => `/get-by-id-linked-account/${id}`,
    ACCOUNTS_POST: `/create-linked-account`,
    ACCOUNT_PATCH: (id: string) => `/edit-linked-account/${id}`,
    ACCOUNTS_DELETE: (id: string) => `/delete-linked-account/${id}`
})

export const PAGE_OVERVIEW_APIS = Object.freeze({
    PAGE_OVERVIEW_UPDATE_DELETE: (id: string) => `/delete/page-overview/${id}`,
    PAGE_OVERVIEW_POST_GET: `/create/page-overview`,
    PAGE_OVERVIEW_DOCUMENT_GET: `/get/page-overview`
})

export const INVESTOR_APIS = Object.freeze({
    INVESTOR_POST_GET: `/investor`,
    INVESTOR_UPDATE_DELETE: (id: string) => `/investor/${id}`,
    KYC_GET: (id: string) => `/investor-document/${id}`,
    KYC_CREATE: `/investor-document`,
    KYC_DELETE: (id: string) => `/investor-document/${id}`,
    AGREEMENT_GET: (investmentId: string) => `/investor-agreement/investor/${investmentId}`,
    AGREEMENT_POST: `/investor-agreement`,
    AGREEMENT_DELETE: (id: string) => `/investor-agreement/${id}`,
    INVESTOR_PROPERTIES_GET: (id: string) => `/investor-investment/${id}`,
    INVESTOR_PROPERTIES_CREATE: `/investor-investment`,
    INVESTOR_PROPERTIES_UPDATE: (investmentId: string) => `/investor-investment/${investmentId}`,
    GET_SINGLE_PROPERTIES: (investmentId: string) => `/investor-investment/single/${investmentId}`,
    INVESTOR_TRANSACTIONS_CREATE: `/investor-transaction`,
    INVESTOR_TRANSACTION_GET: (id: string) => `/investor-transaction/investor/${id}`,
    INVESTOR_PAYOUT_GET: (id: string) => `/investor-payout/investor/${id}`,
    INVESTOR_PAYOUT_CREATE: `/investor-payout`,
    INVESTOR_PAYOUT_UPDATE_DELETE: (payoutId: string) => `/investor-payout/${payoutId}`,
    INVESTOR_SINGLE_PAYOUT_GET: (payoutId: string) => `/investor-payout/${payoutId}`,
    INVESTOR_DOCUMENT_CREATE: `/kor-document`,
    INVESTOR_DOCUMENT_GET_UPDATE_DELETE: (id: string) => `/kor-document/${id}`,
    INVESTOR_PAYOUT_SUMMARY: (investmentId: string, queryParams: string | undefined) =>
        `/investor-payout/preview/${investmentId}?${queryParams}`,
    INVESTOR_FNF_CREATE: `/investor-fnf`,
    INVESTOR_FNF_GET: (investmentId: string) => `/investor-fnf/preview/${investmentId}`,
    INVESTOR_ACTIVITY_GET: (id: string) => `/investor/activity/${id}`
})

export const TENANTS_APIS = Object.freeze({
    TENANTS_GET: `/tenants`,
    TENANT_SINGLE_GET: (id: string) => `/tenant/single/${id}`,
    TENANT_ONBOARDING_DETAILS: (id: string) => `/booking/${id}`,
    TENANT_NAME_UPADTE: (id: string) => `/tenant/${id}`
})
